import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

export default function AuthenticatedRoute({ component: Component, ...rest }) {
    const user = useSelector(state => state.auth.isLogin?.user);
    return <Route {...rest} render={props => user
        ? <Component {...props} />
        : <Redirect to="/" />} />;
}
